<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="ded-center"><b><i>This one is for John Sugden, who told me I should write a biography</i>.</b><span epub:type="pagebreak" id="pagei"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?77d3aab6